import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const App = lazy(() => import('./AppRoutes'));

const AppSuspense = () => {
  const { i18n } = useTranslation();

  if (!i18n.isInitialized) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <App />
    </Suspense>
  );
};

export default AppSuspense;
